import { eventService } from "./resources.service";
import { uniqueEvents } from "./eventDeduplication";

export const HOME_EVENT_COUNT = 15;

export async function fetchHomeEvents(params = {}, listEvents = eventService.list) {
  let page = 1;
  let hasMore = true;
  let events = [];

  while (events.length < HOME_EVENT_COUNT && hasMore) {
    const response = await listEvents({
      ...params,
      page,
      pageSize: HOME_EVENT_COUNT,
    });
    events = uniqueEvents([...events, ...(response.data ?? [])]);
    hasMore = Boolean(response.hasMore);
    page += 1;
  }

  return events.slice(0, HOME_EVENT_COUNT);
}
